// src/utils/routeHelpers.js
import { ROUTES } from '@/config/routes';

/**
 * Returns the client detail route for a given product ID.
 */
export const getClientDetail = (productId) => `${ROUTES.CLIENT_DETAIL}/${productId}`;

/**
 * Returns the admin product detail route for a given product ID.
 */
export const getAdminProductDetail = (productId) => `${ROUTES.ADMIN_PRODUCT_DETAIL}/${productId}`;

/**
 * Returns the admin product edit route for a given product ID.
 */
export const getAdminProductEdit = (productId) => `${ROUTES.ADMIN_PRODUCT_EDIT}/${productId}`;

/**
 * Returns the admin add recipe route (no param).
 */
export const getAdminAddRecipe = () => ROUTES.ADMIN_ADD_RECIPE;

/**
 * Returns the admin add product route (no param).
 */
export const getAdminAddProduct = () => ROUTES.ADMIN_ADD_PRODUCT;
